import * as TK from 'components/PDP/Details/components/PasControl/components/DateSelection/translations/date-selection.locale.constants';

export const dateSelectionCommonLocale = {
  [TK.WHEN]: 'When?',
  [TK.TODAY]: 'Today ({{date}})',
  [TK.TOMORROW]: 'Tomorrow ({{date}})',
  [TK.DATE_PICKER]: 'Select Date',
};
